import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DocuSignResponse {
  docuSignEnvelopeId: string;
  signerUrls: {
    url: string;
    email: string;
    name: string;
  }[];
}

export interface DocuSignPostData {
  webDomain: string;
  redirectUrl: string;
  token: string;
  directCreateDocusign?: boolean;
  isPendingResubmission?: boolean;
  isNewSubmission?: boolean;
}
export interface LoanSignPostData {
  poolingSkuIds: any;
  webDomain: string;
  redirectUrl: string;
  token: string;
  regtankLivenessFeatureFlag?: boolean;
}
export interface SubscriptionDocuSignPostData {
  webDomain: string;
  redirectUrl: string;
  token: string;
  structuredNoteId: number;
  investedAmount: string;
  regtankLivenessFeatureFlag?: boolean;
}

export interface signer {
  name: string;
  email: string;
  status: string;
}

const fetchDocuSignData = async ({
  webDomain,
  redirectUrl,
  token,
}: DocuSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/master-sku-borrower-url`,
      { webDomain, redirectUrl },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    const url = response.data.signerUrls?.[0]?.url || "";
    const { docuSignEnvelopeId } = response.data;
    return { docuSignEnvelopeId, url };
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

const fetchLoanSignData = async ({
  poolingSkuIds,
  webDomain,
  redirectUrl,
  token,
  regtankLivenessFeatureFlag,
}: LoanSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/sn/get-loan-agreement-url`,
      { poolingSkuIds, webDomain, redirectUrl, regtankLivenessFeatureFlag },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    // if (ENV === "production") {
    //   const url = response?.data?.url ?? response.data.signerUrls?.[0]?.url;
    //   const documentId =
    //     response?.data?.documentId ?? response?.data?.docuSignEnvelopeId;
    //   return { documentId, url };
    // } else {
    return response.data;
    // }
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

const fetchSubscriptionDocumentData = async ({
  structuredNoteId,
  investedAmount,
  webDomain,
  redirectUrl,
  token,
  regtankLivenessFeatureFlag,
}: SubscriptionDocuSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/sn/get-subscription-agreement-url`,
      {
        structuredNoteId,
        investedAmount,
        webDomain,
        redirectUrl,
        regtankLivenessFeatureFlag,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    // if (ENV === "production") {
    //   const url = response?.data?.url ?? response.data.signerUrls?.[0]?.url;
    //   const documentId =
    //     response?.data?.documentId ?? response?.data?.docuSignEnvelopeId;
    //   return { documentId, url };
    // } else {
    return response.data;
    // }
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

const fetchSpvBoardResolutionSignData = async ({
  webDomain,
  redirectUrl,
  token,
  directCreateDocusign,
}: DocuSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/get-spv-board-resolution-doc`,
      { webDomain, redirectUrl, directCreateDocusign },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

const fetchBoardResolutionSignData = async ({
  webDomain,
  redirectUrl,
  token,
  directCreateDocusign,
}: DocuSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/get-board-resolution-doc`,
      { webDomain, redirectUrl, directCreateDocusign },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

const fetchIssuerBoardResolutionSignData = async ({
  webDomain,
  redirectUrl,
  token,
  directCreateDocusign,
}: DocuSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/get-issuer-board-resolution-doc`,
      { webDomain, redirectUrl, directCreateDocusign },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

const fetchMasterSkuBorrowerSignData = async ({
  webDomain,
  redirectUrl,
  token,
}: DocuSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/master-sku-borrower-url`,
      { webDomain, redirectUrl },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    // if (ENV === "production") {
    //   const url = response.data.signerUrls?.[0]?.url || "";
    //   const { docuSignEnvelopeId } = response.data;
    //   return { docuSignEnvelopeId, url };
    // } else {
    return response.data;
    // }
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

const fetchDeclarationOfAISignData = async ({
  webDomain,
  redirectUrl,
  token,
  isPendingResubmission,
  isNewSubmission,
}: DocuSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/declaration-of-ai-url`,
      { webDomain, redirectUrl, isPendingResubmission },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    // if (ENV === "production") {
    //   const url = response.data.signerUrls?.[0]?.url || "";
    //   const { docuSignEnvelopeId } = response.data;
    //   return { docuSignEnvelopeId, url };
    // } else {
    return response.data;
    // }
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

const fetchIssuerAgreementSignData = async ({
  webDomain,
  redirectUrl,
  token,
  isNewSubmission,
}: DocuSignPostData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/agreement/issuer-agreement-url`,
      { webDomain, redirectUrl },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export {
  fetchDocuSignData,
  fetchLoanSignData,
  fetchSubscriptionDocumentData,
  fetchSpvBoardResolutionSignData,
  fetchBoardResolutionSignData,
  fetchIssuerBoardResolutionSignData,
  fetchMasterSkuBorrowerSignData,
  fetchDeclarationOfAISignData,
  fetchIssuerAgreementSignData,
};
